import { GridButton } from '@eforall/dashboard';
import { Note } from '@interfaces';


export function getButtons(openNotesDialog: (note?: Note) => Promise<void>) {

	const buttons: GridButton[] = [
		{
			iconClass: 'fa-plus',
			label: 'Add Note',
			execute: async () => {
				await openNotesDialog();
			}
		}
	];

	return buttons;
}